import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatPercent, formatVolume } from '../../../utils/numberFormatFunc';

const BasicCallBoardModalMobile = (props) => {
  const { state, keyName } = props;
  const { activeRow } = state;
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const { expiration } = optionChainReducer;
  const { modalDate, isMobile, ticker } = appReducer;

  return isMobile ? (
    <div>
      <h5
        style={{
          marginBottom: 0,
          marginTop: 10,
          marginLeft: '10px',
          fontSize: '1rem',
        }}
      >
        Options Trade
      </h5>
      <div
        style={{
          color: 'gray',
          marginBottom: '10px',
          marginLeft: '10px',
          fontSize: '0.75rem',
        }}
      >
        {moment(modalDate).format('MMM DD YYYY')}
      </div>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: '#043055', height: '24px' }}>
            <TableCell
              style={{
                color: 'white',
                fontSize: '0.75rem',
                width: '40%',
                padding: 0,
              }}
              align="center"
            >
              OPTION
            </TableCell>
            <TableCell
              style={{
                color: 'white',
                fontSize: '0.75rem',
                width: '10%',
                padding: 0,
              }}
              align="center"
            >
              VOL
            </TableCell>
            <TableCell
              style={{
                color: 'white',
                fontSize: '0.75rem',
                width: '10%',
                padding: 0,
              }}
              align="center"
            >
              OI
            </TableCell>
            <TableCell
              style={{
                color: 'white',
                fontSize: '0.75rem',
                padding: 0,
              }}
              align="center"
            >
              IVOL
            </TableCell>
            <TableCell
              style={{
                color: 'white',
                fontSize: '0.75rem',
                padding: 0,
              }}
              align="center"
            >
              CHG
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={ticker} style={{ height: '24px' }}>
            <TableCell
              style={{
                fontSize: '0.75rem',
                width: '40%',
                padding: 0,
              }}
              align="center"
            >
              {ticker +
                ' ' +
                (expiration ? expiration : '') +
                ' $' +
                activeRow.strike +
                ` ${keyName}`}
            </TableCell>
            <TableCell
              style={{
                fontSize: '0.75rem',
                width: '10%',
                padding: 0,
              }}
              align="center"
            >
              {formatVolume(activeRow.volume)}
            </TableCell>
            <TableCell
              style={{
                fontSize: '0.75rem',
                width: '10%',
                padding: 0,
              }}
              align="center"
            >
              {formatVolume(activeRow.open_int)}
            </TableCell>
            <TableCell
              align="center"
              style={{
                fontSize: '0.75rem',
                width: '10%',
                padding: 0,
              }}
            >
              {formatPercent(activeRow.ivol)}%
            </TableCell>
            <TableCell
              align="center"
              style={{
                fontSize: '0.75rem',
                width: '10%',
                padding: 0,
              }}
            >
              <span
                style={
                  activeRow.ivol_chg > 0 ? { color: 'green' } : { color: 'red' }
                }
              >
                {activeRow.ivol_chg > 0
                  ? '+' +
                    (Math.round(activeRow.ivol_chg * 1000) / 10).toFixed(1)
                  : (Math.round(activeRow.ivol_chg * 1000) / 10).toFixed(1)}
              </span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  ) : null;
};

export default BasicCallBoardModalMobile;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicCallBoard/BasicCallBoardModalMobile.jsx